/*
Controller: Downloads

Operations:
  getBinariesZip
  getImagesZip
*/
var Api = require('../config')

var Downloads = (function () {
  /*
  Operation: getBinariesZip
  Get all binaries as a zip file
  Parameters:
    submissionId: Id of the submission
  Responses:
    HTTP 200: Zip file of Binaries of this submission
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function getBinariesZipDownloads (submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}/download/binaries'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getImagesZip
  Get all images as a zip file
  Parameters:
    submissionId: Id of the submission
  Responses:
    HTTP 200: Zip file of Images of this submission
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function getImagesZipDownloads (submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}/download/images'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getBinariesZip'] = getBinariesZipDownloads
  ret['getImagesZip'] = getImagesZipDownloads
  return ret
})()

module.exports = Downloads
